"use client";

import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AddressAndLanguage from "../../../../(root)/home/components/AddressSelect";

interface MobileMenuProps {
  isOpen: boolean;
  onNavigate: (path: string) => void;
}

const MobileMenu = forwardRef<HTMLDivElement, MobileMenuProps>(
  ({ isOpen, onNavigate }, ref) => {
    const { t } = useTranslation();

    return (
      <div
        ref={ref}
        className={`mobile-menu md:hidden absolute left-0 right-0 z-40 bg-white w-full overflow-hidden transition-all duration-300 shadow-md ${isOpen ? "max-h-screen py-4 border-b border-gray-100" : "max-h-0 py-0 border-none"
          }`}
      >
        <nav className="flex flex-col gap-2 px-4">
          <AddressAndLanguage />
          <button
            onClick={() => onNavigate("/categories")}
            className="flex items-center gap-3 py-2 px-2 hover:bg-red-50 rounded"
          >
            {t("categories")}
          </button>
        </nav>
      </div>
    );
  }
);

MobileMenu.displayName = "MobileMenu";

export default MobileMenu;
